import { Button, Placeholder, Spinner } from "@vkontakte/vkui";
import { Icon28ErrorCircleOutline, Icon28LockOutline } from "@vkontakte/icons";

export function LoadingState() {
  return (
    <Placeholder icon={<Spinner size="large" />}>
      Загружаем данные
    </Placeholder>
  );
}

export function ErrorState({ message, onRetry }: { message: string; onRetry?: () => void }) {
  return (
    <Placeholder icon={<Icon28ErrorCircleOutline />} action={onRetry ? <Button onClick={onRetry}>Повторить</Button> : undefined}>
      {message}
    </Placeholder>
  );
}

export function EmptyState({ title = "Пока пусто", text }: { title?: string; text?: string }) {
  return <Placeholder header={title}>{text}</Placeholder>;
}

export function AccessDenied() {
  return (
    <Placeholder icon={<Icon28LockOutline />} header="Нет доступа">
      У текущей роли нет прав на этот раздел.
    </Placeholder>
  );
}
